import { useState } from 'react'
import { LabelText } from '$components/Services/styledComponents'
import { useUser } from '$context/user'
import DownloadFiles from '$components/Services/OrderedServicesDetails/DownloadFiles'
import { Col, Divider, Row, Input, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const { TextArea } = Input

const ApplyTexturingDetails = ({
  record,
  theme,
  onAcceptOrder,
  onRejectOrder,
  isOrderAccepted = false,
  isOrderRejected = false,
  isMyServicesPage = false,
}) => {
  const { isServiceProvider } = useUser()
  const { t } = useTranslation()
  const [rejectReason, setRejectReason] = useState('')
  const maxChars = 200

  const handleRejectReasonChange = (e) => {
    const value = e.target.value
    if (value.length <= maxChars) {
      setRejectReason(value)
    }
  }

  const handleAccept = () => {
    onAcceptOrder && onAcceptOrder()
  }

  const handleReject = () => {
    if (rejectReason.trim().length > 0) {
      onRejectOrder && onRejectOrder(rejectReason)
    }
  }

  const isEditable = !isOrderAccepted && !isOrderRejected

  const renderInfoSection = () => {
    if (isServiceProvider && isOrderRejected) {
      return (
        <>
          <LabelText>{t('info')}</LabelText>
          <p
            style={{
              color: theme.colorBrightRed500 ?? 'red',
              fontSize: '15px',
            }}
          >
            {t('bookedservices.rejected_by_provider')}
          </p>
          <p
            style={{
              color: theme.colorBrightRed500 ?? 'red',
              fontSize: '12px',
            }}
          >
            {record.provider_rejection_reason}
          </p>
          <Divider />
        </>
      )
    }
    if (isServiceProvider && isEditable) {
      return (
        <>
          <LabelText>{t('info')}</LabelText>
          <p>{t('bookedservices.execute_service')}</p>
          <Divider />
        </>
      )
    }
    return null
  }

  return (
    <Row style={{ width: '100%' }}>
      <Col span={12} style={{ paddingRight: 30 }}>
        {record?.user_file_locations?.length > 0 && (
          <DownloadFiles record={record} style={{ marginBottom: '18px' }} />
        )}
        <LabelText>{t('Details')}</LabelText>
        {t('Is there a visible side')}
        {record.visible_side ? (
          <div>
            <p style={{ textIndent: '15px' }}>
              <b>{t('Yes')}</b>
            </p>
            <div>{t('Where?')}</div>
            <p>
              <i>{record.visible_where}</i>
            </p>
            {t('service.apply_texturing.only_on_visible_side')}
            {record.not_visible_side ? (
              <p style={{ textIndent: '15px' }}>
                <b>{t('Yes')}</b>
              </p>
            ) : (
              <p style={{ textIndent: '15px' }}>
                <b>{t('No')}</b>
              </p>
            )}
          </div>
        ) : (
          <p style={{ textIndent: '15px' }}>
            <b>{t('No')}</b>
          </p>
        )}
      </Col>
      <Col span={12}>
        <LabelText>
          {t('service.apply_texturing.additional_information')}
        </LabelText>
        <Row style={{ width: '100%' }}>
          <Col span={8}>
            {t('service.apply_texturing.depth_of_surface_texture')}:
          </Col>
          <Col span={16}>
            <p>
              <b>{record.depth_of_grain} µm</b>
            </p>
          </Col>
        </Row>
        {record.specifications && (
          <>
            <div>{t('service.apply_texturing.additional_specifications')}:</div>
            <p>
              <i>{record.specifications}</i>
            </p>
          </>
        )}
        {isServiceProvider &&
        isEditable &&
        record.status_info !== 'rejected' &&
        !isMyServicesPage ? (
          <>
            <Divider />
            <LabelText>{t('info')}</LabelText>
            <p>{t('bookedservices.please_accept_or_reject_order')}</p>
            <Row style={{ marginBottom: '16px' }}>
              <LabelText>{t('bookedservices.rejection_reason')}</LabelText>
              <TextArea
                value={rejectReason}
                onChange={handleRejectReasonChange}
                placeholder={t('bookedservices.rejection_reason')}
                rows={3}
                maxLength={maxChars}
                disabled={isOrderRejected}
              />
              <div
                style={{ color: '#999', fontSize: '12px', marginTop: '4px' }}
              >
                {t('bookedservices.only_x_chars_allowed', {
                  count: maxChars,
                })}
              </div>
              <div style={{ marginTop: '5px' }}>
                <Button
                  type="primary"
                  onClick={handleAccept}
                  style={{ marginRight: '8px', marginBottom: '5px' }}
                >
                  {t('bookedservices.accept_and_continue_button')}
                </Button>
                <Button
                  danger
                  onClick={handleReject}
                  disabled={rejectReason.trim().length === 0}
                >
                  {t('bookedservices.reject_and_close_button')}
                </Button>
              </div>
              <Divider />
            </Row>
          </>
        ) : (
          renderInfoSection()
        )}
      </Col>
    </Row>
  )
}

ApplyTexturingDetails.propTypes = {
  theme: PropTypes.shape({
    colorBrightRed500: PropTypes.string,
  }),
  record: PropTypes.shape({
    provider_rejection_reason: PropTypes.string,
  }),
}

export default ApplyTexturingDetails
